<template>
  <div class="ucrs-property__inner">
    <p class="text-xl font-bold mb-9">Famiglie residenti nella zona</p>
    <div class="md:flex md:justify-between md:gap-x-8">
      <div class="md:w-2/3">
        <div class="flex items-center my-8">
          <SvgIcon name="family" class="max-w-13 h-13" />
          <p class="font-bold text-3xl mx-6">
            {{ parseInt(population.pf1.qt).toLocaleString('it-IT') }}
          </p>
          <p class="text-xl">famiglie</p>
        </div>
        <p class="text-lg font-bold mb-7">Famiglie per numero di componenti</p>
        <ChartCaption :items="percentages" />
      </div>
      <LazyPropertyDoughnutChart
        class="max-w-screen-sm mx-auto mt-20 md:m-0 md:w-1/3"
        :items="percentages"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { defineAsyncComponent } from 'vue'
import percentRound from 'percent-round'

// Components
import ChartCaption from '~/components/ChartCaption.vue'
const LazyPropertyDoughnutChart = defineAsyncComponent(() =>
  // TODO: test if lazyness is working and necessary
  import('~/components/PropertyDoughnutChart.vue')
)

export default {
  components: {
    ChartCaption,
    LazyPropertyDoughnutChart,
  },
  props: {
    population: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  computed: {
    percentages() {
      const pf3_perc = this.population.pf3_perc
      const pf4_perc = this.population.pf4_perc
      const pf5_perc = this.population.pf5_perc
      const pf6_perc = this.population.pf6_perc
      const pf7_perc = this.population.pf7_perc
      const pf8_perc = this.population.pf8_perc

      pf3_perc.color = '#d35345'
      pf3_perc.label = '1 componente'
      pf4_perc.color = '#7560b4'
      pf4_perc.label = '2 componenti'
      pf5_perc.color = '#f88450'
      pf5_perc.label = '3 componenti'
      pf6_perc.color = '#fbb800'
      pf6_perc.label = '4 componenti'
      pf7_perc.color = '#006375'
      pf7_perc.label = '5 componenti'
      pf8_perc.color = '#b7e1e9'
      pf8_perc.label = '6+ componenti'

      const percs = [pf3_perc, pf4_perc, pf5_perc, pf6_perc, pf7_perc, pf8_perc]

      const rounded = percentRound(
        percs.map((el) => {
          return el.qt
        })
      )

      percs.forEach((el, i) => {
        el.qt = rounded[i]
      })

      percs.sort((a, b) => b.qt - a.qt)

      return percs
    },
  },
}
</script>
